import ethIcon from '@shared/assets/icons/network-eth.svg';
import tonIcon from '@shared/assets/icons/network-ton.svg';
import tronIcon from '@shared/assets/icons/network-tron.svg';
import solIcon from '@shared/assets/icons/network-sol.svg';

const NETWORK_ICONS: Record<string, string> = {
  ETH: ethIcon,
  ERC20: ethIcon,
  ETHEREUM: ethIcon,
  'ETH NETWORK': ethIcon,
  BSC: ethIcon,
  BEP20: ethIcon,
  TON: tonIcon,
  TONCOIN: tonIcon,
  'TON NETWORK': tonIcon,
  TRX: tronIcon,
  TRON: tronIcon,
  TRC20: tronIcon,
  'TRX 20': tronIcon,
  'TRON (TRX 20)': tronIcon,
  SOL: solIcon,
  SOLANA: solIcon,
  'SOL NETWORK': solIcon,
};

function normalizeNetworkKey(value: string): string {
  return value.trim().toUpperCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
}

export function resolveNetworkIconSrc(networkCode: string | null | undefined): string | null {
  if (!networkCode) return null;
  const key = normalizeNetworkKey(networkCode);
  if (NETWORK_ICONS[key]) return NETWORK_ICONS[key];
  const compact = key.replace(/\s+/g, '');
  if (NETWORK_ICONS[compact]) return NETWORK_ICONS[compact];
  if (key.includes('TRON') || key.includes('TRC') || key.includes('TRX')) return tronIcon;
  if (key.includes('ETH') || key.includes('ERC') || key.includes('BSC') || key.includes('BEP')) return ethIcon;
  if (key.includes('TON')) return tonIcon;
  if (key.includes('SOL')) return solIcon;
  return null;
}
